import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Router from "./router";
import store from "./storage/store";
import { ThemeProvider } from "@material-ui/core";
import { DefaultTheme } from "./constants/materialTheme";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={DefaultTheme}>
        <Router />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
